import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { RefreshConnectivityStatusResData } from "./RefreshConnectivityStatusResData";

const ENDPOINT = "/device_status/connectivity/refresh";

export class RefreshConnectivityStatusCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: RefreshConnectivityStatusReqData = null;
    constructor(installationName: string) {
        super();
        this.params = new RefreshConnectivityStatusReqData(installationName);
    }

    public async execute(): Promise<RefreshConnectivityStatusResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new RefreshConnectivityStatusResData(res);
    }
}

export class RefreshConnectivityStatusReqData {
    installationName: string;

    constructor(installationName: string) {
        this.installationName = installationName;
    }
}
